
    document.addEventListener('DOMContentLoaded', function() {
        document.querySelectorAll('.ft-faq-question').forEach(button => {
            button.addEventListener('click', function() {
                const item = this.closest('.ft-faq-item');
                item.classList.toggle('active');
            });
        });
    });
